import { Intent, Tag } from "@blueprintjs/core"
import { MouseEvent, useEffect, useMemo, useState } from "react"
import { Link } from "react-router-dom"
import { LAND_TYPE, WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import { getRoute, getRouteByComponent } from "src/libs/layouts"
import { Gallery, Likes, LoaderBallsLine } from "src/libs/useful"
import Bookmark from "src/libs/useful/Bookmark"
import { NAVIGATION_TYPE, PAGINATION_TYPE } from "src/libs/useful/gallery/Gallery"
import PeriodLabel from "src/libs/useful/PeriodLabel"
import { __, wordTrim } from "src/libs/utilities"
import actions from "src/modules/pe-basic-module/data/actions"
import { GET_FEED_ACTION } from "src/modules/pe-basic-module/data/actionTypes"
import { useDataStore } from "src/modules/pe-basic-module/data/store"
import useScreenSize from "src/modules/pe-basic-module/hooks/useScreenSize"
import QRCodeButton from "src/modules/pe-basic-module/views/core/QRCodeButton"
import { ILand } from "src/modules/pe-fest-module/data/interfaces"
import EventRequestForm from "../event/EventRequestForm"
import DateLabel from "../labels/DateLabel"
import EventTypeLabel from "../labels/EventTypeLabel"
import Map from "../map/Map"

/* Protopia Ecosystem component */ 
const ToposTop = ( ): JSX.Element => {
    const lands: ILand[] = useDataStore( (state: any) => state.LandBefore || [] )
    const [isLoading, setIsLoading] = useState<boolean>(true) 
    useEffect(() => {
        actions(GET_FEED_ACTION, {
            data_type: "Land",
            seed:"Before",
            paging: ` meta_relation: "AND" metas: [  {key: "land_type", value: "${LAND_TYPE.EVENT}"}, { key: "hidden", value_bool: false },  { key: "archived", value_bool: false }, { key:"status", value_numeric: 0 } ] `,
            // count: 5
        })
        .then(( res: any) => {
            // console.log(res)
            setIsLoading(false)
        })
        .finally(() => setIsLoading(false))
    }, [])
    if( !(lands.length || !isLoading) ) {
        return <div className="col-xl-8-- col-12 topos-head-left flex-centered">
            <LoaderBallsLine />
        </div>
    }
    if(!!lands.length) {
        return <FutureLands />
    } 
    return <div className="topos-top-map w-100 h-md-100">
        <Map />
    </div>
    
}
export default ToposTop


export const FutureLands = ( props: any ): JSX.Element => { 
    const lands: ILand[] = useDataStore( (state: any) => state.LandBefore || [] )
    const land: ILand = useMemo<ILand>(() => {
        if(!!lands.length) {
            const count = Math.floor(Math.random() * lands.length)
            return lands[count]
        }
        return {} as ILand
    }, [lands]) 

    const futureLands = lands.filter(event => event.land_type === LAND_TYPE.EVENT).map( land => <FutureLandSingle land={land} key={land.id} /> )
    return !!land.id
        ?
        <div className="w-100 main-gallery-future">  
            <Gallery 
                items={ [
                    ...futureLands,
                    // ...( futureLands.length < 4 ? [] : [ <div className="w-100 h-100 bg-secondary topos-head-left " /> ] ),
                    // <div className="topos-top-map w-100 h-md-100">
                    //     <Map onOpenLogin={ () => {} } setIsReloading={ setIsReloading } />
                    // </div>
                ]}                     
                itemWidth="100%"   
                galleryContainerClassName="h-100" 
                itemHeight={ 565 } 
                count={1}
                loop
                type="element"
                padding={ 0 }
                navigation={false}
                navigationType={NAVIGATION_TYPE.SQUARE_DARK}
                autoplay={25000}
                pagination
                paginationType={PAGINATION_TYPE.LARGE_RECT}
            />
        </div>
        :
        <div className=" col-12 topos-head-left flex-centered">
            <LoaderBallsLine />
        </div>
}

const FutureLandSingle = ({land, ...props}:any) : JSX.Element => {
    const {width} = useScreenSize()
    const lands: ILand[] = useDataStore( (state: any) => state.LandBefore || [] )
    const url = `/${getRoute( getRouteByComponent("FestivalView")! )}fest/${land?.id}`
    
    const onClick = (evt: MouseEvent<HTMLDivElement>) => {
         evt.preventDefault()
         evt.stopPropagation()   
    }
    const onInvite = ( item: ILand ) => {
        useDataStore.setState({
            LandBefore: lands.map((l: ILand) => {
                if(l.id === item.id) {
                    return {...l, ...item}
                }
                return l
            })
        })
    }
    
    return <Link to={url}  className="w-100 topos-head-left h-100">
    <div className="thumbnail w-100 h-100 card-top-img" style={{backgroundImage:`url(${land.defaultThumbnail})`}}>
        <div className=" card-top-info">
            <div className="pb-3 d-none d-md-flex">
                <Tag className="px-3 py-1 text-uppercase descr text-light smallest" round intent={Intent.SUCCESS} > 
                        {__("Upcoming event")}
                </Tag> 
            </div>                            
            <div className="w-100 d-flex">
                <div className="w-33 flex-grow-100">
                    <div className="h lead-md text-force-contrast mt-2">{land.name}</div>
                    <div className="d-flex align-items-center" onClick={onClick}>
                        <QRCodeButton 
                            item={land} 
                            options={{
                                text:`${window.location.origin}/${getRouteByComponent("FestivalView")?.realRoute}`, 
                                title: '',
                                width:  410,
                                height: 410, 
                            }} 
                            className="p-0" 
                        /> 
                        <Bookmark item={land} className="p-0" />
                        <Likes item={land} dataType='PEFestProject'  className="p-0"  /> 
                    </div> 
                    <div className="small descr text-force-contrast opacity_75">{land.description}</div> 
                    <div className="card-top-content small pt-3  text-force-contrast ">
                        {
                            wordTrim( land.content || "", 60 )
                        }
                    </div>
                </div>
                <div className="w-50 align-items-end justify-content-xl-end mt-2 d-none d-md-flex pr-4 flex-grow-100" onClick={onClick}>
                    <EventRequestForm  item={ land } buttonClassName="py-3 px-4 text-uppercase rounded descr text-light " onInvite={onInvite} />
                </div>
            </div>
        </div> 
        <div className=" m-1 position-absolute top right text-light z-index-1 mt-5">
        {
            width > WINDOW_WIDTH.TABLET
                ?
                <DateLabel item={land} className="mb-3  d-flex" />
                :
                <PeriodLabel start_date={ Number(land.startDate) || 0} finish_date={Number(land.finishDate) || 0} minimal labelClassName="small text-nowrap text-light bg-secondary p-2"/>
        } 
        </div>
        <EventTypeLabel isShort item={ land } className="position-absolute small flex-wrap mx-1 mt-5 z-index-100"/>
    </div>
</Link>
}